var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_content_sub", attrs: { id: _vm.idSetScroll } },
    [
      _c("div", { attrs: { id: "heading_search_item_" + _vm.useType } }, [
        _c(
          "div",
          { staticClass: "setting_options_search d-flex justify-content-end" },
          [
            _c(
              "button",
              {
                staticClass: "setting_btn_secondary setting_btn_medium",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.refreshResourceList($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.screenLabelsProperties.REFRESH_RESOURCE_BUTTON) +
                    "\n      "
                )
              ]
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "setting_options_search setting_options_search_customize"
          },
          [
            _c("p", { staticClass: "setting_options_search_label" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.screenLabelsProperties.SEARCH_JOB_LABEL) +
                  "\n      "
              )
            ]),
            _c("div", { staticClass: "setting_options_search_box" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.computedProperty,
                    expression: "computedProperty"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.screenLabelsProperties.SEARCH_PLACEHOLDER
                },
                domProps: { value: _vm.computedProperty },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getJobResourceFields($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.computedProperty = $event.target.value
                  }
                }
              }),
              _c(
                "button",
                {
                  staticClass: "setting_btn_primary",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.getJobResourceFields($event)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "16",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c(
                        "g",
                        { attrs: { fill: "none", "fill-rule": "evenodd" } },
                        [
                          _c("circle", {
                            attrs: {
                              stroke: "#FFF",
                              "stroke-width": "2",
                              cx: "6.5",
                              cy: "6.5",
                              r: "5.5"
                            }
                          }),
                          _c("path", {
                            attrs: {
                              fill: "#FFF",
                              d: "M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ]
        )
      ]),
      _c(
        "div",
        {
          staticClass: "setting_options_wrapper",
          attrs: { id: "item_resource_wrapper_" + _vm.useType }
        },
        [
          _c(
            "div",
            { staticClass: "setting_options_category" },
            [
              _vm._l(_vm.jobCategories, function(jobCategory) {
                return [
                  _vm.checkEmptyResourceCategory(jobCategory.name) &&
                  jobCategory.is_display === 1
                    ? [
                        _c(
                          "p",
                          {
                            staticClass:
                              "setting_options_category_name jobs mt-3"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(jobCategory.display_name) +
                                "\n          "
                            )
                          ]
                        ),
                        _c(
                          "draggable",
                          {
                            attrs: {
                              group: {
                                name: "item-job",
                                put: false,
                                pull: "clone"
                              },
                              sort: false,
                              list: _vm.resourceFields
                            }
                          },
                          [
                            _vm._l(_vm.resourceFields, function(resourceField) {
                              return [
                                resourceField.isUsed &&
                                !resourceField.isUsed.includes(_vm.useType) &&
                                resourceField.property_category_name ===
                                  jobCategory.name
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "setting_options_category_item",
                                        on: {
                                          mousedown: function($event) {
                                            return _vm.updateCanDragDrop()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "setting_options_category_item_icon",
                                            attrs: {
                                              width: "10",
                                              height: "12",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  fill: "#aaa",
                                                  "fill-rule": "evenodd"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "setting_options_category_item_name"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  resourceField.display_name
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }